import React from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmationModal from '../../../components/confirmation-modal/ConfirmationModal';
import { useMediaStudio } from '../../context/MediaStudioContext';
import { CONFIRM_DIALOGS } from '../../hooks/useFileActions';

const DIALOG_TEXT = {
  [CONFIRM_DIALOGS.RESET]: { labelKey: 'confirmReset', hintKey: 'confirmResetHint' },
  [CONFIRM_DIALOGS.OPEN]: { labelKey: 'confirmOpen', hintKey: 'confirmOpenHint' },
};

function MediaStudioConfirmDialog() {
  const { t } = useTranslation('mediaStudio');
  const { files } = useMediaStudio();
  const text = DIALOG_TEXT[files.confirmDialog?.type];

  return (
    <ConfirmationModal
      isOpen={Boolean(text)}
      onClose={files.closeConfirm}
      onCancel={files.closeConfirm}
      onConfirm={files.confirm}
      label={text ? t(text.labelKey) : ''}
      subLabel={text ? t(text.hintKey) : ''}
    />
  );
}

export default MediaStudioConfirmDialog;
